import React, { Component, Fragment } from 'react';
import { isEmpty, size } from "lodash";
import { Grid, Card, Button, FormControl, Select, InputLabel, MenuItem, OutlinedInput, TextField, FormHelperText, Box, CardHeader, CardContent, CardActions, IconButton, Fab, CardActionArea } from '@mui/material';

import { Edit, Delete, CardGiftcard, AddRounded } from '@mui/icons-material';
import FileUpload from '../../common/FileUpload';
import InputText from '../../common/Form';
import SalaryLine from './SalaryLine';
import SalaryPreview from './SalaryPreview';
import DatePicker from '../../common/DatePicker';
import SalaryCatForm from './SalaryCatForm';
import Dialog from '../../common/Dialog';

class SalaryForm extends Component {
    state = { 
        openPreview: false,
        preview: {},
        salary_employee: "",
        salary_base: "",
        salary_brut: "",
        salary_net: "",
        salary_to_pay: "",
        salary_lines_brut: [],
        salary_lines_net: [],
        salary_lines_to_pay: [],
        salary_period_start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        salary_period_end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
        salary_category: "",
        errors:{
            salary_employee: "",
            salary_base: "",
            salary_brut: "",
            salary_net: "",
            salary_to_pay: "",
            salary_lines_brut: [],
            salary_lines_net: [],
            salary_lines_to_pay: [],
        },

        openCatForm: false,
        salary_cat_name: ""
    }
    
    handleChange = (e) => {
        const { name, value} = e.target;
        this.setState({
            [name]: value
        })
        if( name === "salary_employee" ){
            this.calcTotals(value)
        } else {
            this.calcTotals()
        }
    }

    handleChangeLines = (name, value, index, type) => {
        console.log('=========== handleChangeLines ===============');
        console.log({name, value, index});
        const regexF = /^[-+]?[0-9]*\.?[0-9]+$/ // accept negatives
        
        let cpLines = [].concat(this.state[type])   
        if(name !== "salary_line_name") {
            if (regexF.test(value) || value === "") {
                cpLines[index][name] = parseFloat(value) 
            }
        } else {
            cpLines[index][name] = value 
            cpLines[index].salary_line_rate = value.rate ? value.rate : ""
        }
        console.table(cpLines);

        this.setState({
            ...this.state,
            [type]: cpLines
        })
        this.calcTotals()
    }
    handleChangeDate = (date, name) => {        
        this.setState({            
            [name]: date
        })
    }   
    calcTotals = (employee_id) => {
        console.log('=============== calcTotals =====================');
        console.log('====================================');
        const {salary_lines_brut, salary_lines_net, salary_lines_to_pay, salary_employee} = this.state;
        let base = 0
        let brut = 0
        let net = 0
        let to_pay = 0
        
        let employeeID = salary_employee || employee_id
        if (employeeID) {
            let employee = this.props.EMPLOYEES[employeeID]
            console.log('====================================');
            console.log({employee});
            console.log('====================================');
            base = parseFloat(employee.employee_salary)
            brut = base

            salary_lines_brut.forEach( line => {
                brut += line.salary_line_gain
                brut -= line.salary_line_retenue
            })

            net = brut
            salary_lines_net.forEach( line => {
                net += line.salary_line_gain
                net -= line.salary_line_retenue
            })

            to_pay = net
            salary_lines_to_pay.forEach( line => {
                to_pay += line.salary_line_gain
                to_pay -= line.salary_line_retenue
            })
            this.setState({
                salary_category: employee.employee_accounting
            })
        }
        this.setState({
            salary_base: base,
            salary_brut: brut,
            salary_net: net,
            salary_to_pay: to_pay,
        })
    }
        
    deleteLine = (index, type) => { // net, brut, to_pay
        this.setState({
            [type]: [
                ...this.state[type].slice(0,index),
                ...this.state[type].slice(index +1),
            ],
            errors: {
                ...this.state.errors,
                [type]:[
                    ...this.state.errors[type].slice(0,index),
                    ...this.state.errors[type].slice(index +1),
                ]
            },
        })
    }
    handleAddForm = (type) => { // net, brut, to_pay
        this.setState({
            [type]: [
                ...this.state[type],
                {
                    salary_line_name: "",
                    salary_line_base: "",
                    salary_line_rate: "",
                    salary_line_retenue: "",
                    salary_line_gain: "",
                    salary_line_employer: "",
                }
            ],
            errors: {
                ...this.state.errors,
                [type]:[
                    ...this.state.errors[type],{
                        salary_line_name: "",
                        salary_line_base: "",
                        salary_line_rate: "",
                        salary_line_retenue: "",
                        salary_line_gain: "",
                        salary_line_employer: "",
                    } 
                ]
            },
        })
    }
    createAddForm = (type) => {

        let nbLines = size(this.state[type])
        let tab = []
        for(let i = 0; i < nbLines; i++){
            tab.push(
                <SalaryLine
                    {...this.state[type][i]}
                    errors={this.state.errors[type][i]} 
                    handleChange={this.handleChangeLines} 
                    index={i} 
                    type={type}
                    openNewCat={(name) => this.setState({ openCatForm : true, salary_cat_name: name })}
                    deleteLine={this.deleteLine} 
                    // notif={this.props.notif} 
                    SALARY_CATS={this.props.SALARY_CATS}
                />
            )
        }
        return tab
    }
    setFiles = (salary_files, error = "") => {
        console.log("[INFO] SET_FILES", salary_files);
        this.setState({
            salary_files,
            errors:{
                ...this.state.errors,
                salary_files:error
            }
        })
    }
    validateLines = () => {
        let types = [
            "salary_lines_brut",
            "salary_lines_net",
            "salary_lines_to_pay",
        ]

        let noError = true
        let errors = this.state.errors
        
        types.forEach( type => {
            let lines = [].concat(this.state[type])
            console.log('================= validateLines ===================');
            console.log({lines});
            console.log('====================================');
            lines.forEach( (rubrique, index) => {
                if (isEmpty(rubrique.salary_line_name)){
                    errors[type][index].salary_line_name  = "Veuillez remplir ce champ"
                    noError = false
                } else {
                    errors[type][index].salary_line_name  = ""
                }

                if ( 
                    !rubrique.salary_line_retenue && 
                    !rubrique.salary_line_gain && 
                    !rubrique.salary_line_employer 
                ){
                    errors[type][index].salary_line_retenue  = "Veuillez remplir au moins un champ"
                    errors[type][index].salary_line_gain  = "Veuillez remplir au moins un champ"
                    errors[type][index].salary_line_employer  = "Veuillez remplir au moins un champ"   
                    noError = false
                } else {
                    errors[type][index].salary_line_retenue  = ""
                    errors[type][index].salary_line_gain  = ""
                    errors[type][index].salary_line_employer  = ""   
                }

                if ( rubrique.salary_line_rate && !rubrique.salary_line_base ) {
                    errors[type][index].salary_line_base  = "Veuillez remplir ce champ"   
                    noError = false
                } else {
                    errors[type][index].salary_line_base  = ""   
                }
            })
        })
        
        this.setState({
            errors
        })
        
        return noError
    }
    validate = () => {
        let required = [
            "salary_employee",
            "salary_brut",
            "salary_net",
            "salary_to_pay",
            "salary_period_start",
            "salary_period_end"
        ]
        
        let noError = this.validateLines()
        let errors = this.state.errors
        
        required.map(field => {
            if(this.state[field] === 0) { // possibilité d'avoir un salaire == 0
                errors[field] = "" 
            } else if( isEmpty(this.state[field]) && !this.state[field]) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError = false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        
        this.setState({
            errors
        })
        
        return noError
    }
    
    handlePreview = async () => {

        if( this.validate() ){
            let data = {}
            data.salary_employee = this.state.salary_employee
            data.salary_base = parseFloat(this.state.salary_base)
            data.salary_brut = parseFloat(this.state.salary_brut)
            data.salary_net = parseFloat(this.state.salary_net)
            data.salary_to_pay = parseFloat(this.state.salary_to_pay)
            data.salary_lines_brut = this.state.salary_lines_brut
            data.salary_lines_net = this.state.salary_lines_net
            data.salary_lines_to_pay = this.state.salary_lines_to_pay
            data.salary_period_start = this.state.salary_period_start
            data.salary_period_end = this.state.salary_period_end
            data.salary_files = this.state.salary_files
            data.salary_category = this.state.salary_category
            
            console.log('====================================');
            console.log("preview salary", {data});
            console.log('====================================');
            
            this.setState({
                preview: data,
                openPreview: true
            })
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    handleSubmit = async () => {

        // if( this.validate() ){
            //!\  must validate salary lines
        let data = Object.assign({}, this.state.preview)
        let TYPES = [
            "salary_lines_brut",
            "salary_lines_net",
            "salary_lines_to_pay",
        ]
        TYPES.forEach( type => {
            data[type].forEach( (line, index) => {
                data[type][index].salary_line_name = line.salary_line_name.value
                data[type][index].salary_line_status = "WAITING"
            })
        })
        await this.props.newSalary(data)
        
        // // if NoErrors ...
        if(this.props.STATE.salaries.error){
            this.props.notif("error",`Un problème est survenu: ${this.props.STATE.salaries.error}`)
        } else { 
            this.props.notif("success", "Enregistré")
            this.props.handleClose()
        }
        // } else {
        //     this.props.notif("error", "Le formulaire contient des erreurs")
        // }
    }
    
    render() {
        const { EMPLOYEES, SALARY_CATS, CATEGORIES, STATE, SERVICES, FUNCTIONS } = this.props;
        const { preview, openPreview, openCatForm, salary_cat_name} = this.state;  
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                open={true}
                title="Nouvelle Fiche de Paie"
                appBar
                fullScreen
                close={this.props.handleClose}
                submitAction={this.handlePreview}
                submitTitle="Aperçu"
            >
                {openPreview && !isEmpty(preview) &&
                    <SalaryPreview
                        SERVICES={SERVICES}
                        FUNCTIONS={FUNCTIONS}
                        EMPLOYEES={EMPLOYEES}
                        STATE={STATE}
                        salary={preview}
                        handleClose={() => this.setState({ openPreview: false, preview: {} })}
                        handleSubmit={this.handleSubmit}
                    />
                }
                {openCatForm &&
                    <SalaryCatForm
                        SALARY_CATS={SALARY_CATS}
                        CATEGORIES={CATEGORIES}
                        STATE={STATE}
                        salary_cat_name={salary_cat_name}
                        handleClose={() => this.setState({ openCatForm: false, salary_cat_name: "" })}
                        newSalaryCat={this.props.newSalaryCat}
                        notif={this.props.notif} 
                        createNewCategory={this.props.createNewCategory}
                    />
                }
                    <Grid container spacing={2}>   
                        <Grid item sm={6} xs={12}>
                            <DatePicker 
                                required
                                id="salary_period_start" 
                                label="Du" 
                                name="salary_period_start" 
                                value={this.state.salary_period_start} 
                                handleChange={(date) => this.handleChangeDate(date, "salary_period_start")} 
                                error={this.state.errors.salary_period_start}
                                // maxDate={new Date()}
                            />      
                        </Grid>               
                        <Grid item sm={6} xs={12}>
                            <DatePicker 
                                required
                                id="salary_period_end" 
                                label="Au" 
                                name="salary_period_end" 
                                value={this.state.salary_period_end} 
                                handleChange={(date) => this.handleChangeDate(date, "salary_period_end")} 
                                error={this.state.errors.salary_period_end}
                                // maxDate={new Date()}
                            />      
                        </Grid>               
                        <Grid item xs={12} >
                            <Box p={1}>
                                <FormControl variant="outlined" error={!!this.state.errors.salary_employee} style={{width: "100%"}}>
                                    <InputLabel htmlFor="salary_employee">Employé.e</InputLabel>
                                    <Select
                                        native
                                        onChange={this.handleChange}
                                        error={!!this.state.errors.salary_employee}
                                        value={this.state.salary_employee}
                                        input={
                                            <OutlinedInput 
                                                labelWidth={100} 
                                                name="salary_employee" 
                                                id="salary_employee" 
                                            />
                                        }
                                    >
                                        <option value="" />
                                        { Object.values(EMPLOYEES).map( employee  => (
                                            <option value={employee.employee_id} key={employee.employee_id}>
                                                {employee.employee_lastname.toUpperCase()} - {employee.employee_firstname}
                                            </option>
                                        )) }
                                    </Select>
                                    <FormHelperText>{this.state.errors.salary_employee}</FormHelperText>
                                </FormControl>
                            </Box>
                        </Grid>                
                        {this.state.salary_employee &&
                            <Fragment>
                                <Grid item xs={12}>
                                    <InputText
                                        disabled
                                        label="Salaire de Base"
                                        value={this.state.salary_base}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Card>
                                        <CardHeader 
                                            title="Salaire Brut" 
                                            action={
                                                <Fab size="small" title="Ajouter une ligne" style={{ marginLeft: "auto" }} onClick={() => this.handleAddForm("salary_lines_brut")} color="secondary">
                                                    <AddRounded />
                                                </Fab>
                                            }
                                        />
                                        <CardContent>
                                            {this.createAddForm("salary_lines_brut")}
                                        </CardContent>
                                        <CardActionArea>
                                            <InputText
                                                // required
                                                id="salary_brut"
                                                error={this.state.errors.salary_brut}
                                                value={this.state.salary_brut}
                                                name="salary_brut"
                                                label="Salaire Brut"
                                            />
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                                <Grid item xs={12}>
                                    <Card>
                                        <CardHeader
                                            title="Salaire Net"
                                            action={
                                                <Fab size="small" title="Ajouter une ligne" style={{ marginLeft: "auto" }} onClick={() => this.handleAddForm("salary_lines_net")} color="secondary">
                                                    <AddRounded />
                                                </Fab>
                                            }
                                        />
                                        <CardContent>
                                            {this.createAddForm("salary_lines_net")}
                                        </CardContent>
                                        <CardActionArea>
                                            <InputText
                                                // required
                                                id="salary_net"
                                                error={!!this.state.errors.salary_net}
                                                helperText={this.state.errors.salary_net}
                                                value={this.state.salary_net}
                                                name="salary_net"
                                                label="Salaire Net"
                                            />
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                                <Grid item xs={12}>
                                    <Card>
                                        <CardHeader 
                                            title="Salaire Net à Payer"
                                            action={
                                                <Fab size="small" title="Ajouter une ligne" style={{ marginLeft: "auto" }} onClick={() => this.handleAddForm("salary_lines_to_pay")} color="secondary">
                                                    <AddRounded />
                                                </Fab>
                                            }
                                        />
                                        <CardContent>
                                            {this.createAddForm("salary_lines_to_pay")}
                                        </CardContent>
                                        <CardActionArea>
                                            <Box  style={{ marginLeft: "auto" }}>
                                                <InputText
                                                    // required
                                                    id="salary_to_pay"
                                                    error={!!this.state.errors.salary_to_pay}
                                                    helperText={this.state.errors.salary_to_pay}
                                                    value={this.state.salary_to_pay}
                                                    name="salary_to_pay"
                                                    label="Net à Payer"
                                                />
                                            </Box>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                                <Grid item xs={12}>
                                    <FileUpload
                                        label="Ajouter un Fichier"
                                        setFiles={this.setFiles} 
                                        files={this.state.salary_files || []} 
                                        />
                                    <FormControl error={!!this.state.errors.salary_files}>
                                        <br/>
                                        <FormHelperText >{this.state.errors.salary_files}</FormHelperText>
                                    </FormControl>
                                </Grid>                
                            </Fragment>
                        }
                    </Grid>
            </Dialog>
        );
    }
}

export default SalaryForm;